import { useTranslation } from "react-i18next";
import { Link } from "@caspeco/casper-ui-library.components.link";
import { Text } from "@caspeco/casper-ui-library.components.text";
import { getLocalStorage } from "helpers/local-storage-helper/local-storage-helper";
import { IAppLinks } from "types/app";
import { Button } from "@caspeco/casper-ui-library.components.button";
import {
	ThemeColorVariable,
	ThemeFontSizeVariable,
	ThemeIconSizeVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { Flex } from "@caspeco/casper-ui-library.components.flex";
import { Box } from "@caspeco/casper-ui-library.components.box";
import { Icon, Icons } from "@caspeco/casper-ui-library.components.icon";
import Popover from "components/popover/Popover";

export function AllergensInfo() {
	const { t } = useTranslation();
	const allergyInfoURL = getLocalStorage<IAppLinks>("links")?.allergyInfoURL;

	if (allergyInfoURL) {
		return (
			<Box mt={ThemeSpaceVariable.Small}>
				<Link
					href={allergyInfoURL}
					target="_blank"
					color={ThemeColorVariable.OnSurface}
					fontSize={ThemeFontSizeVariable.Small}
				>
					<Flex gap={ThemeSpaceVariable.XSmall} align="center">
						{t("article_allergens")}
						<Icon icon={Icons.LinkExternal} size={ThemeIconSizeVariable.XSmall} />
					</Flex>
				</Link>
			</Box>
		);
	}
	return (
		<Box width="fit-content">
			<Popover
				id="article_allergens"
				content={<Text>{t("article_allergens_info")}</Text>}
				aria-label={`popover-${"article_allergens"}`}
			>
				<Button
					mt={ThemeSpaceVariable.Small}
					size="sm"
					variant="tertiary"
					display="flex"
					gap={ThemeSpaceVariable.XSmall}
					rightIcon={Icons.CircleInfo}
				>
					{t("article_allergens")}
				</Button>
			</Popover>
		</Box>
	);
}
